module.exports = __webpack_public_path__ + "fonts/iconfont.bd4fc237.ttf";